/**
Reducer for managing the state when creating the care plan report
*/

import {
  GET_ID_TRANSFER,
  GET_ID_TRANSFER_DONE,
  GET_ID_TRANSFER_ERROR
} from '../actions/types';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  hasError: false
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_ID_TRANSFER_DONE:
      return {
        ...state,
        ...action.data,
        hasError: false,
        isProcessing: false
      };
    case GET_ID_TRANSFER:
      return {
        ...state,
        isProcessing: true,
        hasError: false
      };
    case GET_ID_TRANSFER_ERROR:
      return {
        ...state,
        isProcessing: false,
        hasError: true
      };
    default:
      return state;
  }
};
